import React from 'react';
import '../styles/config-title.scss';


interface Props {
	textBottom: string;
}

export const ConfigTextBottom: React.FunctionComponent<Props> = props => {
	return (
		<div className='config-title--wrapper'>
			<div className={'config-text__bottom'}>{props.textBottom}</div>
		</div>
	);
};

